/* global CONFIG */
import OpoliWidget from './modules/widget.js'

if (!window.opoli) window.opoli = new OpoliWidget(CONFIG)



// WEBPACK FOOTER //
// ./src/main.js